"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { useId } from "react";
import { ROLL_QUANTITY_ERROR } from "@/lib/product/validation";
import { useNewCartStore } from "@/stores/useNewCartStore";
import { PackagingMode } from "@/utils/resolvePackagingMode";
import { getRollDriver, needsRollSelection, type RollDriverSelection } from "@/utils/rollQuantityUtils";
import type { CartPackagingOption } from "./cartPackagingUtils";
import { PackagingQuantitySelect } from "./PackagingQuantitySelect";
export interface Props {
  item: CartItemOutputDto;
  mode: PackagingMode;
  options: CartPackagingOption[];
  selectedOption: CartPackagingOption | null;
  isLoading: boolean;
  showError: boolean;
  onPackagingQuantityChange: (selection: RollDriverSelection) => void;
}
export function CartItemPackagingQuantity(t0) {
  const $ = _c(34);
  const {
    item,
    mode,
    options,
    selectedOption,
    isLoading,
    showError,
    onPackagingQuantityChange
  } = t0;
  let t1;
  if ($[0] !== item.id) {
    t1 = state => state.lostRollSelectionItemIds.includes(item.id);
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRollSelectionLost = useNewCartStore(t1);
  const labelId = useId();
  const rollErrorId = useId();
  let errorMessage;
  let label;
  let rollDriver;
  let t2;
  let t3;
  if ($[2] !== isRollSelectionLost || $[3] !== item || $[4] !== mode) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      rollDriver = getRollDriver(item);
      const hasRollDriver = mode === PackagingMode.Roll && rollDriver !== null;
      if (!item.quantity) {
        t3 = null;
        break bb0;
      }
      if (!hasRollDriver) {
        t3 = null;
        break bb0;
      }
      label = mode === PackagingMode.Roll ? "Roll Quantity" : "Bundle Quantity";
      errorMessage = `We couldn't update the ${mode} quantity. Please try again.`;
      t2 = mode === PackagingMode.Roll && needsRollSelection({
        rollDriver,
        rollCount: item.rollCount
      }, isRollSelectionLost);
    }
    $[2] = isRollSelectionLost;
    $[3] = item;
    $[4] = mode;
    $[5] = errorMessage;
    $[6] = label;
    $[7] = rollDriver;
    $[8] = t2;
    $[9] = t3;
  } else {
    errorMessage = $[5];
    label = $[6];
    rollDriver = $[7];
    t2 = $[8];
    t3 = $[9];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const showRollError = t2;
  let t4;
  if ($[10] !== label || $[11] !== labelId) {
    t4 = <p id={labelId} className="font-semibold">{label}</p>;
    $[10] = label;
    $[11] = labelId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = showRollError ? rollErrorId : undefined;
  let t6;
  if ($[13] !== isLoading || $[14] !== isRollSelectionLost || $[15] !== labelId || $[16] !== mode || $[17] !== onPackagingQuantityChange || $[18] !== options || $[19] !== rollDriver || $[20] !== selectedOption || $[21] !== t5) {
    t6 = <PackagingQuantitySelect mode={mode} rollDriver={rollDriver} options={options} selectedOption={selectedOption} isRollSelectionLost={isRollSelectionLost} isLoading={isLoading} onValueChange={onPackagingQuantityChange} labelId={labelId} errorId={t5} />;
    $[13] = isLoading;
    $[14] = isRollSelectionLost;
    $[15] = labelId;
    $[16] = mode;
    $[17] = onPackagingQuantityChange;
    $[18] = options;
    $[19] = rollDriver;
    $[20] = selectedOption;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== rollErrorId || $[24] !== showRollError) {
    t7 = showRollError && <p id={rollErrorId} className="text-sm text-destructive">{ROLL_QUANTITY_ERROR}</p>;
    $[23] = rollErrorId;
    $[24] = showRollError;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== errorMessage || $[27] !== showError) {
    t8 = showError && <p role="alert" className="text-sm text-destructive">{errorMessage}</p>;
    $[26] = errorMessage;
    $[27] = showError;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t4 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t4}{t6}{t7}{t8}</div>;
    $[29] = t4;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
}